import ButtonV2 from "@/components/shared/buttonV2";
import { Photos } from "@/types/common/photos";

type Props = {
  media: Photos[] | undefined;
  hasRotateDegree: boolean;
  handleRotate: (media: Photos[] | undefined) => void;
  closeModal: () => void;
};

const saveButton = ({
  media,
  hasRotateDegree,
  handleRotate,
  closeModal
}: Props) => {
  return (
    <div className="left-0 w-full items-center px-16">
      <div className="flex justify-center">
        <ButtonV2
          variant={hasRotateDegree ? "primary" : "neutral"}
          layout="fullWidth"
          disabled={!hasRotateDegree}
          click={(e: React.MouseEvent) => {
            handleRotate(media);
            closeModal();
            e.stopPropagation();
          }}
        >
          保存する
        </ButtonV2>
      </div>
    </div>
  );
};

export default saveButton;
